import { render, staticRenderFns } from "./pagefooter.vue?vue&type=template&id=ed442e56&scoped=true&"
var script = {}
import style0 from "./pagefooter.vue?vue&type=style&index=0&id=ed442e56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed442e56",
  null
  
)

export default component.exports